export const generateDynamicColumn = (
  columnsData: {
    title: string;
    isSorter?: boolean;
    dataIndex: string;
    width?: string;
  }[],
  actions?: any,
  sortOrder?: string | null,
  sortField?: string
) => {
  const columnsArr: any[] = [];

  columnsData.forEach((item) => {
    const result = {
      ...item,
      ...(item.isSorter
        ? {
            sortOrder: sortField === item.dataIndex ? sortOrder : null,
            sorter: true,
            sortDirections: ["ascend", "descend", null],
            defaultSortOrder: null,
          }
        : {}),
      width: item.width,
      ellipsis: true,
    };
    columnsArr.push(result);
  });

  return actions ? [...columnsArr, actions] : columnsArr;
};
export const pageSizeOptions = ["10", "20", "50", "100"];
